// import React, { useRef, useState, useEffect } from "react";
// import {
//   GoogleMap,
//   Marker,
//   LoadScript,
//   StandaloneSearchBox,
//   useJsApiLoader,
// } from "@react-google-maps/api";
// import "./HomeAddress.scss";
// const containerStyle = {
//   width: "400px",
//   height: "400px",
// };

// const center = {
//   lat: -3.745,
//   lng: -38.523,
// };
// let autoComplete;

// const loadScript = (url, callback) => {
//   let script = document.createElement("script");
//   script.type = "text/javascript";

//   if (script.readyState) {
//     script.onreadystatechange = function () {
//       if (script.readyState === "loaded" || script.readyState === "complete") {
//         script.onreadystatechange = null;
//         callback();
//       }
//     };
//   } else {
//     script.onload = () => callback();
//   }

//   script.src = url;
//   document.getElementsByTagName("head")[0].appendChild(script);
// };
// const HomeAddress = ({ setSelectedLocation }) => {
//   const inputRef = useRef();
//   const handlePlacedChanged = () => {
//     const [place] = inputRef.current.getPlaces();
//     if (place) {
//       console.log(place);
//     }
//   };
//   const { isLoaded } = useJsApiLoader({
//     id: "google-map-script",
//     googleMapsApiKey: "AIzaSyCj9hR4ijU4BYkh-ugnYLfwShnmug-7wrM",
//   });

//   const [map, setMap] = React.useState(null);

//   const onLoad = React.useCallback(function callback(map) {
//     // This is just an example of getting and using the map instance!!! don't just blindly copy!
//     const bounds = new window.google.maps.LatLngBounds(center);
//     map.fitBounds(bounds);

//     setMap(map);
//   }, []);

//   const onUnmount = React.useCallback(function callback(map) {
//     setMap(null);
//   }, []);
//   const [query, setQuery] = useState("");
//   const autoCompleteRef = useRef(null);

//   const handleScriptLoad = (updateQuery, autoCompleteRef) => {
//     autoComplete = new window.google.maps.places.Autocomplete(
//       autoCompleteRef.current,
//       {
//         // types: ["(cities)"],
//         componentRestrictions: { country: "IN" },
//       }
//     );

//     autoComplete.addListener("place_changed", () => {
//       handlePlaceSelect(updateQuery);
//     });
//   };

//   const handlePlaceSelect = async (updateQuery) => {
//     const addressObject = await autoComplete.getPlace();

//     const query = addressObject.formatted_address;
//     updateQuery(query);
//     console.log({ query });

//     const latLng = {
//       lat: addressObject?.geometry?.location?.lat(),
//       lng: addressObject?.geometry?.location?.lng(),
//     };

//     console.log({ latLng });
//     setSelectedLocation(latLng);
//   };
//   useEffect(() => {
//     loadScript(
//       "https://maps.googleapis.com/maps/api/js?key=AIzaSyCj9hR4ijU4BYkh-ugnYLfwShnmug-7wrM&libraries=places",
//       () => handleScriptLoad(setQuery, autoCompleteRef)
//     );
//   }, []);
//   return (
//     <>
//       {/* <LoadScript
//         googleMapsApiKey="AIzaSyCj9hR4ijU4BYkh-ugnYLfwShnmug-7wrM"
//         libraries={["places"]}
//       >
//         <StandaloneSearchBox
//           onLoad={(ref) => (inputRef.current = ref)}
//           onPlacesChanged={handlePlacedChanged}
//         >
//           <input
//             type="text"
//             className="form-control"
//             placeholder="Enter location"
//           />
//         </StandaloneSearchBox>
//       </LoadScript> */}
//       {/* <LoadScript googleMapsApiKey={"AIzaSyCj9hR4ijU4BYkh-ugnYLfwShnmug-7wrM"}> */}
//       {/* {isLoaded ? (
//         <GoogleMap
//           mapContainerStyle={containerStyle}
//           center={center}
//           zoom={10}
//           onLoad={onLoad}
//           onUnmount={onUnmount}
//         >
//           <StandaloneSearchBox
//             onLoad={(ref) => (inputRef.current = ref)}
//             onPlacesChanged={handlePlacedChanged}
//           >
//             <input
//               type="text"
//               className="form-control"
//               placeholder="Enter location"
//             />
//           </StandaloneSearchBox>
//         </GoogleMap>
//       ) : (
//         <></>
//       )} */}
//       {/* </LoadScript> */}
//       <div className="search-location-input">
//         <label>Type in your suburb or postcode</label>
//         <input
//           ref={autoCompleteRef}
//           className="form-control"
//           onChange={(event) => setQuery(event.target.value)}
//           placeholder="Search Places ..."
//           value={query}
//         />
//       </div>
//     </>
//   );
// };
// export default HomeAddress;

import React, { useEffect, useRef, useState } from "react";
//import { REACT_APP_GOOGLE_MAPS_KEY } from "../constants/constants";

let autoComplete;

const loadScript = (url, callback) => {
  let script = document.createElement("script");
  script.type = "text/javascript";

  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = () => callback();
  }

  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
};

const HomeAddress = ({ setSelectedLocation }) => {
  const [query, setQuery] = useState("");
  const autoCompleteRef = useRef(null);

  const handleScriptLoad = (updateQuery, autoCompleteRef) => {
    autoComplete = new window.google.maps.places.Autocomplete(
      autoCompleteRef.current,
      {
        types: ["(cities)"],
        componentRestrictions: { country: "IN" },
      }
    );

    autoComplete.addListener("place_changed", () => {
      handlePlaceSelect(updateQuery);
    });
  };

  const handlePlaceSelect = async (updateQuery) => {
    const addressObject = await autoComplete.getPlace();

    const query = addressObject.formatted_address;
    updateQuery(query);
    console.log({ query });

    const latLng = {
      lat: addressObject?.geometry?.location?.lat(),
      lng: addressObject?.geometry?.location?.lng(),
    };

    console.log({ latLng });
    setSelectedLocation(latLng);
  };

  useEffect(() => {
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=AIzaSyCj9hR4ijU4BYkh-ugnYLfwShnmug-7wrM&libraries=places`,
      () => handleScriptLoad(setQuery, autoCompleteRef)
    );
  }, []);

  return (
    <div className="search-location-input">
      <label>Type in your suburb or postcode</label>
      <input
        ref={autoCompleteRef}
        className="form-control"
        onChange={(event) => setQuery(event.target.value)}
        placeholder="Search Places ..."
        value={query}
      />
    </div>
  );
};

export default HomeAddress;
